// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 846 ? "Flickity" : chunkId) + "." + {"442":"72ea132805d0c1ad3ab8","846":"f07bd45d82c312cb7cfd"}[chunkId] + ".js";
};